import React from 'react';
import PropTypes from "prop-types";
import MUISelect from 'material-ui/Select';
import InputLabel from 'material-ui/Input/InputLabel';
import tsl from '../../app/tsl';
import withValidations from './withValidations';
import FormHelperText from 'material-ui/Form/FormHelperText';
import FormControl from 'material-ui/Form/FormControl';
import { isValueSelected } from './validations';

export class SelectWithFeedback extends React.Component {
  render() {
    const {
      helperText,
      ...componentProps
    } = this.props;

    return (
      <MUISelect
        {...componentProps}
      />
    );
  }
}

const ValidatedSelect = withValidations(
  SelectWithFeedback,
  (val) => isValueSelected(val) !== true ? isValueSelected(val) : true
);

export default ValidatedSelect;


// WEBPACK FOOTER //
// ./components/forms/ValidatedSelect.js